// extracted by mini-css-extract-plugin
export default {"backButton":"BackNavBar_backButton__X-0P5"};